export default __webpack_public_path__ + "static/media/TaxReporting.f71241b6.jpg";